const reviewDisplay = (reviewRating = 0, reviewCount = 0, productLink = '') => ({
    reviewRating,
    reviewCount,
    productLink,
    reviewStars: [],
    elementID: '#reviews',

    // "review" or "reviews" for the count, in the page's language: forms is { one, few, other }, where few is the
    // Polish 2-4 form (2 opinie, but 5 opinii)
    reviewCountWord(forms) {
        const form = new Intl.PluralRules(document.documentElement.lang || undefined).select(parseInt(this.reviewCount, 10))

        return forms[form] ?? forms.other
    },
    init() {
        if (productLink.length && productLink !== this.elementID) {
            this.productLink = productLink + this.elementID
        }

        const remainder = this.reviewRating % 1
        const fullStars = parseInt(this.reviewRating - remainder, 10)

        for (let index = 1; index <= fullStars; index += 1) {
            this.reviewStars.push({
                percentage: 99.99,
                id: `review-star-${Math.random()}-${index}`,
            })
        }

        if (this.reviewStars.length < 5) {
            this.reviewStars.push({
                percentage: parseInt(remainder * 100, 10),
                id: `review-star-${Math.random()}-remainder`,
            })
        }

        while (this.reviewStars.length < 5) {
            this.reviewStars.push({
                percentage: 0,
                id: `review-star-${Math.random()}-empty`,
            })
        }
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('reviewDisplay', reviewDisplay)
})
